import {
    REFERENCE_PROJECTS_DECISION_WITH,
    REFERENCE_PROJECTS_DECISION_WITHOUT,
} from './parseReply';
import type { ReferenceProjectsReply } from './parseReply';

/**
 * Builds the `data` half of the wire payload for a reference-projects reply.
 *
 * Reproduces the pilot's payload byte for byte, including the redundant `value` object: the
 * backend prompt contract reads work IDs from `value.referenceProjects` as a comma-joined string,
 * not from the `workIds` array, and `value.referenceProjectsDecision` rather than `decision`. Both
 * spellings are sent because the pilot sent both — dropping either is a backend contract change,
 * not a cleanup, and belongs with ESMTCM-1178.
 *
 * Isolated in its own module so this frozen shape has a single test and a single place to change.
 */
export function toWireData(reply: ReferenceProjectsReply): Record<string, unknown> {
    if (reply.decision === REFERENCE_PROJECTS_DECISION_WITHOUT) {
        return {
            decision: REFERENCE_PROJECTS_DECISION_WITHOUT,
            value: {
                referenceProjectsDecision: REFERENCE_PROJECTS_DECISION_WITHOUT,
            },
        };
    }

    return {
        decision: REFERENCE_PROJECTS_DECISION_WITH,
        workIds: reply.workIds,
        value: {
            referenceProjectsDecision: REFERENCE_PROJECTS_DECISION_WITH,
            referenceProjects: reply.workIds.join(','),
        },
    };
}
